import { Component, Inject,ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { HttpParams } from '@angular/common/http';
import { PTicketFilterComponent } from "../../pTicket/p-ticket-filter/p-ticket-filter.component";
import { ReportingGraphComponent } from "../reporting-graph/reporting-graph.component";
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { ChartType } from 'chart.js';
import { pTicket } from '../../../interfaces/pTicket';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { Filter } from '../../../interfaces/filter';
import { Filters } from '../../../mock-data/mock-filters';
import { MatIconModule } from '@angular/material/icon';
import { ReportService } from '../../../services/report.service';
import { report, xAxisOption } from '../../../interfaces/preport';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-report-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    PTicketFilterComponent,
    ReportingGraphComponent,
    FormsModule,
    NgFor,
    NgIf,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
],
  templateUrl: './new-report-dialog.component.html',
  styleUrl: './new-report-dialog.component.scss'
})
export class NewReportDialogComponent {
  report: report;
  selectedXAxis: keyof pTicket = 'pct_has_solution';
  activeFilters: { key: Filter, value: string }[] = [];
  xAxisOptions: xAxisOption[] = [
    { key: 'pct_has_solution', label: 'Has Solution' },
    { key: 'pct_supportlevel', label: 'Support Level' },
    { key: 'pct_status', label: 'Status' },
    { key: 'pct_tickettype', label: 'Ticket Type' },
    { key: 'pct_company', label: 'Company' },
    { key: 'pct_countrycode', label: 'Country' },
    { key: 'pct_issuetype', label: 'Issue Type' },
    { key: 'pct_severity', label: 'Severity' },
    { key: 'pct_component', label: 'Component' },
    { key: 'pct_status_granulated', label: 'Granulated status' },
    { key: 'pkeywords', label: "Keywords"},
    { key: 'pct_product', label: "Product" }
  ];

  editingTitle = false;
  isSavingChanges : boolean = false;
  @ViewChild(ReportingGraphComponent) reportingGraphComponent!: ReportingGraphComponent;
  constructor(
    public dialogRef: MatDialogRef<NewReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { report?: report; id: number },
    private reportService: ReportService,
    private router :Router,
  ) {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    this.report = data.report
      ? { ...data.report }
      : {
        id: -1,
        rep_title: 'New Report',
        rep_chartType: 'bar',
        rep_xAxisOption: this.xAxisOptions[0],
        rep_filter: new HttpParams()
          .set('updatedAt[$gte]', thirtyDaysAgo.toISOString())
          .set('updatedAt[$lte]', today.toISOString()),
      };
  }


  ngOnInit(): void {

    if (this.data.report) {
      this.report = this.data.report;
    }
    this.activeFilters = [];
    this.loadActiveFilters(this.report.rep_filter);
    this.activeFilters = [...this.activeFilters]; // force Angular to detect change
    this.reportingGraphComponent.loadTickets(this.report);
  }

  onXAxisChange(newXAxis: string) {
    const selectedKey = newXAxis as keyof pTicket;
    this.selectedXAxis = selectedKey;
    this.report.rep_xAxisOption = {
      key: selectedKey,
      label: this.xAxisOptions.find(o => o.key === selectedKey)?.label || selectedKey
    };
    this.reportingGraphComponent.loadTickets(this.report);
    
  }

  onTypeChange(newType: ChartType) {

    this.report.rep_chartType = newType;
    this.reportingGraphComponent.loadTickets(this.report);
  }

  onFilterChange(filter: HttpParams = new HttpParams()): void {

    this.report.rep_filter = filter;
    this.reportingGraphComponent.loadTickets(this.report);
  }

  loadActiveFilters(filters: HttpParams): void {
    this.activeFilters = []; // reset

    filters.keys().forEach(key => {
      const filterDef = Filters.find(f => f.db_key === key);

      if (!filterDef) {
        console.warn(`Unknown filter key: ${key}`);
        return; // skip unknown keys
      }

      const values = filters.getAll(key);
      values?.forEach(value => {
        this.activeFilters.push({ key: filterDef, value });
      });
    });

    this.activeFilters = [...this.activeFilters];
  }




  save(): void {
    this.isSavingChanges = true;
    const payload: report = {
      ...this.report,
      rep_filter: this.report.rep_filter instanceof HttpParams
        ? this.report.rep_filter
        : new HttpParams({ fromObject: this.report.rep_filter as any })
    };
    if (this.report.id == -1) {
      this.reportService.create(payload).subscribe({
        next: (createdReport) => {
          this.dialogRef.close(createdReport); // Return to parent
        },
        error: (err) => {
          console.error('Error saving report:', err);
        }
      });
    }
    else {
      this.reportService.update(payload).subscribe({
        next: (updatedReport) => {
          this.isSavingChanges = false;
          this.dialogRef.close(updatedReport); // Return to parent
        }
      });
    }

  }

  cancel(): void {
    this.dialogRef.close();
  }

  toggleEditTitle(): void {
    this.editingTitle = !this.editingTitle;
  }
}
